/**
 * MSW Override: Included ancillary not available scenario
 *
 * Intercepts POST /bookings/quotation and returns an INCLUDED_ANCILLARY_NOT_AVAILABLE
 * error, simulating the case where a subscription add-on SSR is unavailable
 * for the selected flight during the quotation step.
 *
 * Enable by setting ENABLE_MSW=true and
 * NUXT_PUBLIC_MSW_OVERRIDES_INCLUDED_ANCILLARY_NOT_AVAILABLE=true in your .env,
 * then restart the dev server.
 */

import type { HttpHandler } from 'msw';
import { http, HttpResponse } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';

export function createIncludedAncillaryNotAvailableOverrides(baseUrl: string): HttpHandler[] {
  return [
    http.post(
      `${baseUrl}/${toMSWPattern(BFF_ENDPOINTS.QUOTATION)}`,
      () => {
        return HttpResponse.json(
          { code: 'INCLUDED_ANCILLARY_NOT_AVAILABLE', message: 'An included SSR is not available for this flight.' },
          { status: 422 },
        );
      },
    ),
  ];
}
